var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"form-button",class:{
    'has-icon-right': _vm.hasIconRight,
    'has-icon-left': _vm.hasIconLeft,
    'is-outlined': _vm.isOutlined,
    'is-link': _vm.isLink,
    'is-small': _vm.isSmall,
    'is-loading': _vm.isLoading,
  },attrs:{"disabled":_vm.disabled || _vm.isLoading}},[_vm._t("default",function(){return [_vm._v("Button")]}),(_vm.isLoading)?_c('LoadingIcon',{staticClass:"form-button__loader"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }